import { Card, CardActions, CardProps, Divider, Stack, Typography, useTheme } from '@mui/material'
import { grey } from '@mui/material/colors'
import { FC, ReactNode } from 'react'

interface ListCardProps {
  title?: string
  subTitle?: string
  actions?: ReactNode
}

export const ListCard: FC<ListCardProps & CardProps> = ({
  children,
  actions,
  elevation = 2,
  subTitle,
  title,
  ...cardProps
}) => {
  const {
    palette: { mode },
  } = useTheme()
  return (
    <Card elevation={elevation} {...cardProps}>
      <Stack divider={<Divider />}>
        <Stack px={1.5} py={1} sx={{ backgroundColor: grey[mode === 'light' ? 100 : 800] }}>
          {!!title && <Typography variant="caption">{title}</Typography>}
          {!!subTitle && <Typography>{subTitle}</Typography>}
        </Stack>
        {children}
        {!!actions && <CardActions>{actions}</CardActions>}
      </Stack>
    </Card>
  )
}
